import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { jsPDF } from "jspdf";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import {
  deleteSponsor,
  deleteAssociatedAppuser,
  loadSponsorData,
  openSponsorModal,
  isimportant,
  updateSponsorFiles,
  filesChanged,
  deleteSponsorAdv,
  fetchSponsorQr,
} from "ActionsSponsors";
import { showError, showSuccess } from "ReduxErrorBar";
import { checkContentDashboardStatus } from "GeneralTabAction";
import LocaleStrings from "Languages";

class SponsorListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      delLoading: false,
      delAssociatedUser: false,
    };
  }

  open = () => {
    this.setState({ showModal: true });
  };

  close = () => {
    this.setState({
      showModal: false,
      delLoading: false,
      delAssociatedUser: false,
    });
  };

  handleCheckbox = (e) => {
    var value = e.target.checked;
    this.setState({ delAssociatedUser: value });
  };

  deleteSponsorCallback(sponsor) {
    var { delAssociatedUser } = this.state;
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    // confirmAlert({
    //   title: "Delete",
    //   message: LocaleStrings.content_spon_text_delete_spo,
    //   confirmLabel: "OK",
    //   cancelLabel: "CANCEL",
    //   onConfirm: () => {
    //     var sponsorid = this.props.sponsor.sponsorid;
    //     this.props.deleteSponsor(this.props.session, sponsorid, (result) => {
    //       if (result.error) {
    //         this.props.showError(COMMON_FAIL_MESSAGE);
    //       } else {
    //         this.props.showSuccess("Sponsor deleted successfully");
    //         this.props.checkContentDashboardStatus(this.props.session);
    //         this.props.pagination(pageNo);
    //       }
    //     });
    //   },
    //   onCancel: () => {},
    // });
    this.props.deleteSponsorAdv(
      this.props.session,
      this.props.sponsor.sponsorid,
      (result) => {
        if (result.error) {
          // this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          // this.props.showSuccess("Social deleted successfully!");
          // this.props.checkContentDashboardStatus(this.props.session);
        }
      }
    );

    var sponsorid = this.props.sponsor.sponsorid;
    this.setState({ delLoading: true });
    if (delAssociatedUser === true) {
      this.props.deleteAssociatedAppuser(
        this.props.session,
        sponsorid,
        (response) => {
          if (response.success === 0) {
            this.props.showError(LocaleStrings.sponsor_error_message);
            this.setState({ delLoading: false });
          } else {
            this.props.deleteSponsor(
              this.props.session,
              sponsorid,
              (result) => {
                this.setState({ delLoading: false });
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.close();
                  this.props.showSuccess(
                    LocaleStrings.sponsor_dlt_successfully
                  );
                  this.props.checkContentDashboardStatus(this.props.session);
                  this.props.pagination(pageNo);
                }
              }
            );
          }
        }
      );
    } else {
      this.props.deleteSponsor(this.props.session, sponsorid, (result) => {
        this.setState({ delLoading: false });
        if (result.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.close();
          this.props.showSuccess("Sponsor deleted successfully");
          this.props.checkContentDashboardStatus(this.props.session);
          this.props.pagination(pageNo);
        }
      });
    }
  }

  editSponsorCallback(obj) {
    var sponsor = this.props.sponsor;

    var fileName1 = "";
    var fileName2 = "";
    var fileName3 = "";
    var fileName4 = "";
    var fileName5 = "";
    if (sponsor.file1) {
      var f1 = sponsor.file1.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName1 = f2 + "." + ext;
    }
    if (sponsor.file2) {
      var f1 = sponsor.file2.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName2 = f2 + "." + ext;
    }
    if (sponsor.file3) {
      var f1 = sponsor.file3.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName3 = f2 + "." + ext;
    }
    if (sponsor.file4) {
      var f1 = sponsor.file4.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName4 = f2 + "." + ext;
    }
    if (sponsor.file5) {
      var f1 = sponsor.file5.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName5 = f2 + "." + ext;
    }

    var files = [
      {
        position: "file1",
        file: sponsor.file1 ? sponsor.file1 : "",
        filename: fileName1,
      },
      {
        position: "file2",
        file: sponsor.file2 ? sponsor.file2 : "",
        filename: fileName2,
      },
      {
        position: "file3",
        file: sponsor.file3 ? sponsor.file3 : "",
        filename: fileName3,
      },
      {
        position: "file4",
        file: sponsor.file4 ? sponsor.file4 : "",
        filename: fileName4,
      },
      {
        position: "file5",
        file: sponsor.file5 ? sponsor.file5 : "",
        filename: fileName5,
      },
    ];
    this.props.loadSponsorData(sponsor);
    this.props.openSponsorModal({ showModal: true });
    this.props.updateSponsorFiles(files);
    this.props.filesChanged({ ischanged: false });
  }

  important = () => {
    let { sponsor, session } = this.props;
    let imp = true;
    if (sponsor && sponsor.featured) {
      imp = false;
    }

    this.props.isimportant(session, sponsor, imp, (response) => {
      if (!response.success) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.operationsCallback();
      }
    });
  };

  selectionCallback = (user) => {
    // var user = this.props.appUser;
    this.props.checkAndUncheckUsers(user);
  };

  downloadPdfF = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("element :- ", e);
    let { sponsor, session, eventDetails } = this.props;

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.schedule_sessionqr_download_title}</h1>
            <p>{LocaleStrings.schedule_sessionqr_download_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.setState({ QrDownloadLoading: true });
                  this.props.fetchSponsorQr(
                    session,
                    { sponsorid: sponsor.sponsorid, eventid: session.eventid },
                    (response) => {
                      // console.log("response", response);
                      onClose();
                      this.setState({ QrDownloadLoading: false });
                      if (response.success === 0) {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else {
                        let qrString = response.data.qr;

                        let themecolor = eventDetails.themecolor;
                        let eventname = eventDetails.eventname;
                        let imgData = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;

                        const doc = new jsPDF("p", "pt", [8.3 * 72, 11.7 * 72]);
                        let getPageWidth =
                          doc.internal.pageSize.width ||
                          doc.internal.pageSize.getWidth();

                        doc.setFillColor(`${themecolor}`);
                        doc.rect(0, 0, 8.3 * 72, 66, "F");

                        doc.setFontSize(20);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Sponsor Qr`, 37, 20 + 20);

                        let titleFont = 24;

                        doc.setFontSize(titleFont);
                        doc.setFont(`Helvetica`, `normal`, `700`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${sponsor.name}`, 37, 80 + titleFont, {
                          maxWidth: getPageWidth - 70,
                        });

                        // doc.setFontSize(17);
                        // doc.setFont(`Helvetica`, `normal`, `400`);
                        // doc.setTextColor(`#000000`);
                        // doc.text(`Date  :  ${date}`, 37, 170 + 17);

                        // doc.setFontSize(17);
                        // doc.setFont(`Helvetica`, `normal`, `400`);
                        // doc.setTextColor(`#000000`);
                        // doc.text(`Time  :  ${stime} - ${etime}`, 37, 196 + 17);

                        doc.setFillColor(`#000000`);
                        doc.roundedRect(100, 249, 395, 437, 10, 10, "F");

                        doc.addImage(qrString, "JPEG", 110, 259, 375, 347);

                        doc.setFontSize(36);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Scan Me`, 225, 620 + 36);

                        doc.addImage(imgData, "JPEG", 274, 708, 50, 50);

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${eventname}`, getPageWidth / 2, 760 + 17, {
                          align: "center",
                          maxWidth: getPageWidth,
                        });

                        doc.save(`${sponsor.name}.pdf`);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  render() {
    var { session, sponsor, selectedUsers } = this.props;
    var { showModal, delLoading } = this.state;
    var membership = sponsor.membershiptype_by_categoryid;

    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.sponsorid === sponsor.sponsorid;
    });

    var checked = false;
    if (index >= 0) {
      checked = true;
    }

    var tagURL = "";
    if (membership.membershiptype == "bronze") {
      tagURL = "../../style/images/custom-icons/bronze.svg";
    } else if (membership.membershiptype == "silver") {
      tagURL = "../../style/images/custom-icons/silver.svg";
    } else if (membership.membershiptype == "gold") {
      tagURL = "../../style/images/custom-icons/gold.svg";
    } else {
      tagURL = "../../style/images/custom-icons/platinum.svg";
    }

    var imgURL = "../../style/images/placeholder_600x400.svg";
    if (
      sponsor.logoimgpath !== "" &&
      sponsor.logoimgpath !== undefined &&
      sponsor.logoimgpath != null
    )
      imgURL = `${BASE_IMAGES_URL}/${sponsor.logoimgpath}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;

    var iconURL = `../../style/images/custom-icons/compound-shape.svg`;
    if (sponsor.featured) {
      iconURL = `../../style/images/custom-icons/compound-shape-copy.svg`;
    }

    var style = {
      marginTop: "1px",
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
    };

    let catNameStyle = {
      position: "relative",
      right: 95,
      // bottom: 10,
      color: membership.textcolor,
    };

    return (
      <tr key={sponsor.sponsorid}>
        <td>
          <label
            className="custom-container-checkbox"
            style={{ marginTop: -1 }}
          >
            <input
              type="checkbox"
              onChange={() => this.selectionCallback(sponsor)}
              checked={checked}
            />
            <span className="checkmark" />
          </label>
        </td>
        <td>
          <div className="d-flex">
            <div style={style}></div>
            <div className="pt-5 pl-15 pr-15">
              <img
                onClick={this.important}
                className="i-custom-star pointer"
                src={iconURL}
              />
            </div>
            <div className="vcenter">{sponsor.name}</div>
          </div>
        </td>
        <td>
          <div className="vcenter">
            {/* <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="97" height="29">
                <path
                  fill={membership.bgcolor}
                  fillRule="evenodd"
                  d="M88.362 12.578c-1.049 1.061-1.049 2.783 0 3.845l7.845 7.936c1.693 1.713.494 4.641-1.9 4.641H5c-2.761 0-5-2.239-5-5V5c0-2.761 2.239-5 5-5h89.307c2.394 0 3.593 2.928 1.9 4.641l-7.845 7.937z"
                />
              </svg>
              <span style={catNameStyle}>
                {membership.membershiptitle.toUpperCase()}
              </span>
            </div> */}

            {/* <img className="i-custom-membership" src={tagURL}/> */}
            {/* <div className="shape">
              <div className="triangle-list"></div>
              <div className="square" style={{color:membership.textcolor,background:membership.bgcolor}}>{membership.membershiptitle.toUpperCase()}</div>
            </div> */}
            <div className="shape-left">
              <div className="triangle-left"></div>
              <div
                className="square-left"
                style={{ color: membership, background: membership.bgcolor }}
              >
                {membership.membershiptitle.toUpperCase()}
              </div>
            </div>
          </div>
        </td>

        {/*<td>{sponsor.title}</td>*/}
        <td>
          <div className="d-flex">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editSponsorCallback.bind(this)}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            {session.eventid == 1775833435293321 ||
            session.eventid == 1759600095065910 ||
            session.eventid == 1776788702911330 ||
            session.eventid == 1785019292857123 ||
            session.eventid == 1725453736959263 ? (
              <div className="action-button vcenter">
                <button
                  className="btn btn-custom-table-white"
                  onClick={(e) => this.downloadPdfF(e)}
                >
                  {LocaleStrings.button_qr_download}
                </button>
              </div>
            ) : (
              ""
            )}
            <div className="action-button vcenter">
              <button className="i-custom-table-delete" onClick={this.open}>
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>

          {showModal === true ? (
            <Modal
              className="modal-container"
              show={showModal === true ? true : false}
              onHide={this.close}
              animation={true}
              keyboard={false}
              backdrop="static"
              dialogClassName="modal-md"
              enforceFocus={false}
            >
              <Modal.Header>
                <div className="import-modal-title">{`Delete Sponsor`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group">
                  <p>{LocaleStrings.content_spon_text_delete_spo}</p>
                  <p>
                    {
                      LocaleStrings.content_common_text_delete_associated_user_confirm
                    }
                  </p>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="deleteassociateduser"
                    className="custom-container-checkbox"
                  >
                    {LocaleStrings.content_common_text_delete_associated_user}
                    <input
                      type="checkbox"
                      id="deleteassociateduser"
                      name="deleteassociateduser"
                      // value={true}
                      onChange={this.handleCheckbox}
                    />
                    <span className="checkmark" />
                  </label>
                  <p>
                    {
                      LocaleStrings.content_common_text_delete_associated_user_note
                    }
                  </p>
                  <p>
                    {
                      LocaleStrings.content_exhi_text_delete_sponsor_and_addBanner
                    }
                  </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-custom-white" onClick={this.close}>
                  {LocaleStrings.button_cancel}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={delLoading}
                  onClick={this.deleteSponsorCallback.bind(this)}
                  disabled={delLoading}
                >
                  {LocaleStrings.button_delete}
                </Button>
              </Modal.Footer>
            </Modal>
          ) : (
            ""
          )}
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  deleteSponsor,
  deleteAssociatedAppuser,
  loadSponsorData,
  openSponsorModal,
  showError,
  showSuccess,
  checkContentDashboardStatus,
  isimportant,
  updateSponsorFiles,
  filesChanged,
  deleteSponsorAdv,
  fetchSponsorQr,
})(SponsorListItem);
